var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.283,
    height: 14.507,
    viewBox: "0 0 11.283 14.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.806,15.895a1.617,1.617,0,0,0,1.612,1.612h6.447a1.617,1.617,0,0,0,1.612-1.612V6.224H5.806ZM16.283,3.806H13.462L12.656,3H8.627l-.806.806H5V5.418H16.283Z",
    transform: "translate(-5 -3)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.a1e32e703f36b7ae40f6bbe776de0899.svg";
export { ForwardRef as ReactComponent };